import styled from "styled-components";

export const Container = styled.div`
  overflow-y: auto;
  height: calc(100% - ${({ theme }) => theme.editor.editorHeaderHeight});
  overflow-x: clip;
  font-family: ${({ theme }) => theme.fontMedium};
  background-color: ${({ theme }) => theme.editor.backgroundDark};

  grid-row-start: 2;
  grid-row-end: 3;
  display: grid;
  grid-template-columns: ${({ tightLayout, theme }) =>
    tightLayout
      ? theme.editor.tightLaneControlsW
      : theme.editor.laneControlsW} auto;

  .rc-slider-handle {
    border: 0;
    background-color: ${({ theme }) => theme.editor.textDark};

    &:hover {
      background-color: ${({ theme }) => theme.editor.light};
      transform: scale(1.2);
    }
  }

  .zoom-button,
  .snap-button {
    width: 26px;
  }

  #drag-overlay {
    position: absolute;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    top: 2px;
    right: 2px;
    bottom: 2px;
    left: 2px;
    z-index: 9999;
  }

  &&::-webkit-scrollbar {
    width: 12px;
  }

  &&::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.editor.backgroundDark};
  }

  &&::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.editor.backgroundHighlight};
    border-radius: 20px;
    border: 2px solid ${({ theme }) => theme.editor.backgroundDark};
  }
`;

export const LanesAreaContainer = styled.div`
  overflow-x: auto;
  height: 100%;
  position: relative;

  .split-mode {
    cursor: col-resize;
  }

  &&::-webkit-scrollbar {
    height: 12px;
  }

  &&::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.editor.backgroundDark};
  }

  &&::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.editor.backgroundHighlight};
    border-radius: 20px;
    border: 2px solid ${({ theme }) => theme.editor.backgroundDark};
  }
`;

export const MarkerOverlay = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  background-color: rgba(194, 194, 194, 0.6);
  pointer-events: none;
  z-index: 10;
  mix-blend-mode: multiply;
  transition: 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transform-origin: top left;
`;

export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: clip;
  transform-origin: left;
  background-color: ${({ theme }) => theme.editor.backgroundMedium};
  background-size: ${({ backgroundSize }) => backgroundSize}px;
  background-position: ${({ initialBeatOffset }) => initialBeatOffset}px 0;
  background-image: linear-gradient(
    to right,
    ${({ theme }) => theme.editor.backgroundLight} 1px,
    transparent 2px
  );
  width: fit-content;
  min-width: calc(100vw - ${({ theme }) => theme.editor.laneControlsW});
  height: 100%;
  position: relative;
`;

export const LeftPanelContainer = styled.div`
  background-color: ${({ theme }) => theme.editor.backgroundDark};

  .top-bar {
    display: flex;
    align-items: center;
    height: 36px;
    padding: 0 10px 0 15px;
  }
`;
